import {create} from 'zustand'
import {devtools} from 'zustand/middleware'

export const userStore = create(devtools((set) => ({
    user: null,
    session: null,
    setUser: (newUser) => set(() => ({ user: newUser })),
    setSession: (newSession) => set(() => ({ session: newSession })),
}), "userStore"));